<template>
  <div>
    <slot>
      <div
        v-if="!dialogVisible"
        class="drage_btn"
        @click="dialogVisible = true"
      />
      <div
        v-else
        class="drage_btn active"
        @click="dialogVisible = true"
      />
    </slot>
    <el-dialog
      title="自定义列"
      :visible.sync="dialogVisible"
      width="40%"
      :close-on-click-modal="false"
      @close="close"
    >
      <el-row type="flex">
        <el-col
          :span="16"
          class="col_left"
        >
          <el-row :gutter="10">
            <el-checkbox
              v-model="checkAll"
              :indeterminate="isIndeterminate"
              class="check_all_info"
              @change="handleCheckAllChange"
            >
              全选
            </el-checkbox>
            <el-checkbox-group
              v-model="checkList"
              @change="handleCheckedCitiesChange"
            >
              <template v-for="city in tableOpt">
                <el-checkbox
                  v-if="isKeyName(jsonName,city)"
                  :key="city"
                  :label="city"
                >
                  {{ isKeyName(jsonName,city) }}
                </el-checkbox>
              </template>
            </el-checkbox-group>
          </el-row>
        </el-col>
        <el-col
          :span="8"
          style="background: #efefef"
        >
          <div class="board-column-header">
            排序展示
          </div>
          <draggable
            :list="checkList"
            v-bind="$attrs"
            class="board-column-content"
            :set-data="setData"
          >
            <div
              v-for="element in checkList"
              :key="element"
              class="board-item"
            >
              {{ isKeyName(jsonName,element) }}
            </div>
          </draggable>
        </el-col>
      </el-row>
      <span
        slot="footer"
        style="display: flex;justify-content: center"
      >
        <template>
          <el-button @click="close">取消</el-button>
          <el-button
            type="primary"
            @click="dataFormSubmit"
          >确定</el-button>
        </template>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import draggable from 'vuedraggable'
import {customDrageInfo,saveCustomDrage} from "@/api/article";
export default{
  components:{
    draggable
  },
  props:{
    all:{
      type:Array,
      default(){
        return []
      }
    },
    check:{
      type:Array,
      default(){
        return []
      }
    },
    jsonName:{
      type:String,
      default:''
    },
    id:{
      type:String,
      default:''
    },
  },
  data(){
    return {
      tableOpt:[],
      checkList:[],
      dialogVisible:false,
      checkAll: false,
      isIndeterminate: true
    }
  },
  created() {
    this.tableOpt = [...[],...this.all]
    this.tableOpt = this.tableOpt.filter(item=>{
      if(this.isKeyName(this.jsonName,item)){
        return item
      }
    })
    this.checkList = [...[],...this.check]
    this.handleCheckedCitiesChange(this.checkList)
    this.getData()
  },
  methods:{
    getData(){
      customDrageInfo({router:`${this.$route.path}${this.id}`}).then(res=>{
          if(res.data&&res.data.jsons){
            this.checkList = JSON.parse(res.data.jsons)
            this.$forceUpdate()
            this.dataFormSubmit()
          }
      })
    },
    dataFormSubmit(){
      saveCustomDrage({router:`${this.$route.path}${this.id}`,jsons:JSON.stringify(this.checkList)}).then(res=>{
        this.$emit('update',this.checkList)
        this.dialogVisible = false
      })
    },
    close(){
      this.dialogVisible = false
      this.checkList = [...[],...this.check]
    },
    setData(dataTransfer) {
      // to avoid Firefox bug
      // Detail see : https://github.com/RubaXa/Sortable/issues/1012
      dataTransfer.setData('Text', '')
    },
    handleCheckAllChange(val) {
      this.checkList = val ? [...[],...this.tableOpt] : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.tableOpt.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.tableOpt.length;
    }
  }
}
</script>
<style lang="less" scoped>
.drage_btn{
  width: 28px;
  height: 28px;
  background: url("../../assets/images/drage.png") no-repeat;
  cursor: pointer;
  &:hover, &:active, &.active{
    background: url("../../assets/images/drage_acitve.png") no-repeat;
  }
}
/deep/.check_all_info.is-checked{
  .el-checkbox__label{
    color: #303133 !important;
  }
}
.col_left{
  background: #F6F7F9;
  border-radius: 4px 4px 4px 4px;
  margin-right: 10px;
  .el-row{
    padding: 10px 20px;
    max-height: 192px;
  }
}
.board-column-header {
  height: 30px;
  line-height: 30px;
  overflow: hidden;
  padding: 0 20px;
  text-align: center;
  background: rgba(227,238,250);
  color: #333;
  border-radius: 4px 4px 0 0;
}
.board-column-content {
  height: 100%;
  max-height: 200px;
  overflow: auto;
  padding: 8px 10px;
  min-height: 30px;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  background: #F6F7F9;

  .board-item {
    cursor: pointer;
    width: 100%;
    height: 30px;
    margin-top: 8px;
    text-align: left;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px 10px;
    box-sizing: border-box;
    background: #FFFFFF;
    box-shadow: 0px 2px 4px 1px rgba(0, 0, 0, 0.1);
    border-radius: 0px 0px 0px 0px;
    &:first-child{
      margin-top: 0;
    }
  }
}
/deep/ .el-checkbox-group{
  display: flex;
  flex-flow: wrap;
  .el-checkbox{
    width: 33%;
    margin-right: 0;
  }
}
</style>
